<template>
  <div class="seomain">
    <div class="info-main">
      <div class="info-top">
        <span>采购单号：</span>
        {{ stinfo.code }}
      </div>
      <div class="info-mid">
        <h1>{{ stinfo.logisticsnumber ? stinfo.logisticsnumber : "暂无物流单号" }}</h1>
        <p>物流单号</p>
      </div>
      <div class="info-bottom text-center">
        <dl>
          <dt>供应商</dt>
          <dd>{{ stinfo.warehouse_out_name }}</dd>
        </dl>
        <dl>
          <dt>采购仓库</dt>
          <dd>{{ stinfo.warehouse_in_name }}</dd>
        </dl>
      </div>
    </div>

    <div class="tab-content">
      <div class="st-list-box pan-105">
        <div class="st-list" v-for="(v, k) in stlist" :key="k" :index="k">
          <div class="st-list-top">
            <div class="t-tit">{{ v.sku }}</div>
          </div>
          <div class="st-list-main">
            <p>品类：{{ v.cname }}</p>
            <p>品牌：{{ v.brand }}</p>
            <p>型号：{{ v.model }}</p>
            <p>配置：{{ v.deploy }}</p>
            <p>总数量：{{ v.quantity }}</p>
            <p>已签收数量：{{ v.signinged }}</p>
            <p>备注：{{ v.remark }}</p>
          </div>
          <div
            class="st-list-bottom"
            @click="
              show = true;
              dialogActiveId = v.purchase_products_id;
              dialog_num = '';
            "
            v-if="flag != 'false'"
          >
            <p class="st-opt-btn">签 收</p>
          </div>
        </div>
      </div>
    </div>

    <div class="footer pf-btm">
      <div class="btn" @click="onAllSingfor">
        全部签收
      </div>
    </div>

    <van-dialog v-model="show" show-cancel-button @confirm="edit_st2">
      <div class="mix-detail-box" v-if="dialogStlist">
        <h2>SKU：{{ dialogStlist.sku }}</h2>
        <p>品类：{{ dialogStlist.cname }}</p>
        <p>品牌：{{ dialogStlist.brand }}</p>
        <p>型号：{{ dialogStlist.model }}</p>
        <p>配置：{{ dialogStlist.deploy }}</p>
        <p>总数量：{{ dialogStlist.quantity }}</p>
        <p>已签收数量：{{ dialogStlist.signinged }}</p>
        <el-input v-model="dialog_num" placeholder="请输入签收数量"></el-input>
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      fieldValue: "",
      cascaderValue: "",
      options: [
        {
          text: "深圳旗丰仓",
          value: "1",
          children: [
            {
              text: "深圳旗丰仓",
              value: "0",
              children: [
                {
                  text: "仓位1",
                  value: "1",
                },
                {
                  text: "仓位2",
                  value: "2",
                },
              ],
            },
            {
              text: "子仓库A",
              value: "1",
              children: [
                {
                  text: "仓位3",
                  value: "3",
                },
                {
                  text: "仓位4",
                  value: "4",
                },
              ],
            },
            {
              text: "子仓库B",
              value: "1",
              children: [
                {
                  text: "仓位5",
                  value: "5",
                },
                {
                  text: "仓位6",
                  value: "6",
                },
              ],
            },
          ],
        },
      ],
      dialog_num: "",
      show: !1,
      stlist: [],
      stinfo: {},
      paramsid: 0,
      activeid: 0,
      dialogActiveId: 1, // 确定dialog显示数据的标识
    };
  },
  watch: {},
  computed: {
    flag() {
      return this.$route.params.flag;
    },
    dialogStlist() {
      let result = this.stlist.filter((item) => item.purchase_products_id == this.dialogActiveId);
      return result[0];
    },
    id() {
      return this.$route.params.id;
    },
  },
  methods: {
    edit_st2: function() {
      let t = this;
      if (this.$isEmpty(this.dialog_num)) {
        return this.$toast("请先填写内容");
      } else {
        t.edit();
      }
    },
    get_st_info: function() {
      let paramsid = this.$route.params.id;
      this.$post(this.$api.stGetCaigouQianshouList, { id: paramsid }).then((res) => {
        console.log(res);
        this.stlist = res.data.list;
        this.stinfo = res.data.info;
      });
    },
    async edit() {
      let result = this.$post(this.$api.stsetCaigouQianshouEdit, { id: this.dialogActiveId, stnum: this.dialog_num });
      this.$toast.success("已签收,请等待上级确认.");
      this.get_st_info();
    },
    // 签收此单下所有的物品
    async onAllSingfor() {
      try {
        let flag = await this.$dialog.confirm({
          title: "签收所有",
          message: "确认此采购单下所有物品数量无误,\n并全部签收.",
        });
        if (flag != "confirm") return;
        // 发起请求签收全部
        let result = await this.$post(this.$api.stGetCaigouAuthSginfor, { code: this.stinfo.code });
        this.get_st_info();
        this.$toast.success("一键签收成功.");
      } catch (error) {}
    },
  },
  created() {
    this.get_st_info();
    window.h5sdk.ready(function() {
      window.h5sdk.biz.navigation.setTitle({ title: "采购签收" });
    });
  },
  mounted() {},
};
</script>
<style lang="scss" scoped>
.info-main {
  padding-top: 10px;
  background: #345;
  margin-bottom: 15px;
}
.info-main .info-top {
  color: #9ab;
  line-height: 2;
  margin: 0 20px;
}
.info-main .info-mid {
  text-align: center;
  color: #fff;
}
.info-main .info-mid h1 {
  line-height: 2.2;
  font-weight: normal;
}
.info-main .info-mid p {
  color: #9ab;
}
.info-main .info-bottom {
  display: flex;
  background: #2f3e50;
  border-top: 1px solid #9ab;
  margin-top: 20px;
  padding: 5px 0;
}
.info-main .info-bottom dl {
  flex: 1;
  line-height: 1.8;
}
.info-main .info-bottom dt {
  color: #9ab;
}
.info-main .info-bottom dd {
  color: #fff;
}

.info-scan {
  margin-top: 2.5em;
  margin-right: 1.5em;
}
.info-scan .van-icon {
  color: #0ba;
  font-size: 50px;
}

.info-detail-list {
  padding: 10px 20px;
  background: #fff;
}
.info-detail-list dl {
  display: flex;
  border-bottom: 1px solid #e5e5e5;
  line-height: 30px;
  padding-top: 10px;
  padding-bottom: 5px;
}
.info-detail-list dt {
  flex: 1;
}
.info-detail-list .num {
  padding: 0 10px;
}
.info-detail-list .icon {
  color: #ddd;
  font-weight: bolder;
  font-size: 24px;
}

.status-00 {
  font-weight: normal;
}
.status-01 {
  color: #43cf7c;
}
.status-02 {
  color: #ff5733;
}
.seomain .tab-content {
  box-sizing: border-box;
  padding-bottom: 50px;
}
.footer {
  position: fixed;
  bottom: 0;
  height: 50px;
  box-sizing: border-box;
  padding: 5px 16px;
  width: 100%;
  height: 50px;
  border-top: 1px solid #cccccc;
  background-color: #fff;
}
.seomain .pf-btm .btn {
  box-sizing: border-box;
  text-align: center;
  line-height: 40px;
  color: #fff;
  border-radius: 16px;
  background-color: #00baad;
}
</style>
